// extracted by mini-css-extract-plugin
export default {"icon":"checkbox_icon-module___icon___dc273661","iconVisible":"checkbox_icon-module___iconVisible___f4781418"};